import React, { useEffect } from "react";
import { useFormik } from "formik";
import { yupSchemaStep6 } from "schemas/yupSchema";
import { goToTop, refToErrorFormik } from "helpers/helpers";
import { requestJson, RequestMethod } from "helpers/httpHelper";
import { prepareDataStep6 } from "helpers/PrepareData";
import { toast } from "react-toastify";
import Adresa from "components/Adresa";
import Step6DateIdentificareCetateanRoman from "components/Step6/Step6DateIdentificareCetateanRoman";
import Step6DateIdentificareCetateanStrain from "components/Step6/Step6DateIdentificareCetateanStrain";
import NavigateButtons from "components/NavigateButtons";
import CustomInput from "components/CustomInput";

export default function Step6({ currentStep, setCurrentStep, stepsState, persistState, setLoading, firstSubmit, setFirstSubmit, tipCetatenie }) {
   const formik = useFormik({
      enableReinitialize: true,
      initialValues: {
         ...stepsState.step6,
         telefon: stepsState.step3.telefon,
         email: stepsState.step3.email,
         nume: tipCetatenie === "STRAIN" ? stepsState.step3.nume : stepsState.step6.nume,
         prenume: tipCetatenie === "STRAIN" ? stepsState.step3.prenume : stepsState.step6.prenume,
      },
      validationSchema: yupSchemaStep6,
      validateOnChange: firstSubmit,
      validateOnBlur: false,
      onSubmit: values => {
         goToTop();
         saveData(values);
      },
   });

   const saveData = async values => {
      setLoading(true);
      var opportunityId = stepsState.opportunityId;
      if (opportunityId === undefined || opportunityId === null) {
         console.log('opportunityId is undefined or null');
         toast.error("Va rugam sa incercati din nou.");
         return false;
      }
      const allData = { ...values, opportunityId: stepsState.opportunityId, step3: stepsState.step3, tipCetatenie: tipCetatenie, step2: stepsState.step2 };
      const response = await requestJson(process.env.REACT_APP_API_ENDPOINT_B2C_PAS6, RequestMethod.POST, { data: prepareDataStep6(allData) });
      if (response.isSuccess) {
         persistState(prevState => {
            return {
               ...prevState,
               step6: {
                  ...prevState.step6,
                  nume: values.nume,
                  prenume: values.prenume,
                  serieCI: values.serieCI, //Cetatean_ROMAN
                  numarCI: values.numarCI, //Cetatean_ROMAN
                  emisDeCI: values.emisDeCI, //Cetatean_ROMAN
                  emisLaCI: values.emisLaCI, //Cetatean_ROMAN
                  expiraLaCI: values.expiraLaCI, //Cetatean_ROMAN
                  cnp: values.cnp, //Cetatean_ROMAN
                  nif: values.nif, //Cetatean_STRAIN
                  nrPasaport: values.nrPasaport, //Cetatean_STRAIN
                  emisLaPasaport: values.emisLaPasaport, //Cetatean_STRAIN
                  expiraLaPasaport: values.expiraLaPasaport, //Cetatean_STRAIN
                  taraEmitenta: values.taraEmitenta, //Cetatean_STRAIN
                  domiciliu: values.domiciliu,
                  consum: values.consum,
                  adresaConsumDomiciliu: values.adresaConsumDomiciliu,
                  telefon: values.telefon,
                  email: values.email,
                  facturaMail: values.facturaMail,
                  corespondenta: values.corespondenta,
               },
            };
         });
         window.dataLayer.push({ event: "pas_6_casnici", info: { pagina: "step-6", finalizat: "da" } });
         setCurrentStep(currentStep + 1);
         localStorage.setItem("sessionCurrentStep", currentStep + 1);
         setFirstSubmit(false);
      } else {
         toast.error("Nu s-au putut salva datele. Va rugam sa incercati din nou.");
      }
      setLoading(false);
   };

   const formSubmition = e => {
      e.preventDefault();
      setFirstSubmit(true);
      formik.handleSubmit();
   };

   useEffect(() => {
      refToErrorFormik(formik);
   }, [formik]);

   return (
      <section className="mt-80 mb-80">
         <div className="container">
            <div className="row">
               <div className="col-md-8 ml-auto mr-auto">
                  <div className="pas-6">
                     <h2 className="first_title">DATE DE IDENTIFICARE</h2>
                     <p className="contr-sub">DATE DE IDENTITATE</p>
                     <form onSubmit={e => formSubmition(e)}>
                        <div className="row row-input mt-50">
                           <div className="col-md-6 mb-768">
                              <label htmlFor="prenume">Prenume</label>
                              <CustomInput
                                 id={"prenume"}
                                 name={"prenume"}
                                 type={"text"}
                                 placeholder={tipCetatenie === "ROMAN" ? "Prenumele complet din cartea de identitate" : "Prenume"}
                                 value={formik.values.prenume}
                                 error={formik.errors.prenume}
                                 touched={formik.touched.prenume}
                                 setFieldValue={formik.setFieldValue}
                                 preventNumbers={true}
                              />
                           </div>
                           <div className="col-md-6">
                              <label htmlFor="nume">Nume</label>
                              <CustomInput
                                 id={"nume"}
                                 name={"nume"}
                                 type={"text"}
                                 placeholder={tipCetatenie === "ROMAN" ? "Numele din cartea de identitate" : "Nume"}
                                 value={formik.values.nume}
                                 error={formik.errors.nume}
                                 touched={formik.touched.nume}
                                 setFieldValue={formik.setFieldValue}
                                 preventNumbers={true}
                              />
                           </div>
                        </div>

                        {tipCetatenie === "ROMAN" ? (
                           <Step6DateIdentificareCetateanRoman
                              formikValues={formik.values}
                              formikErrors={formik.errors}
                              formikTouched={formik.touched}
                              setFieldValue={formik.setFieldValue}
                           />
                        ) : (
                           <Step6DateIdentificareCetateanStrain
                              formikValues={formik.values}
                              formikErrors={formik.errors}
                              formikTouched={formik.touched}
                              setFieldValue={formik.setFieldValue}
                           />
                        )}

                        <Adresa
                           title={"ADRESA LOCULUI DE CONSUM"}
                           textInfoTitle={true}
                           hoverText={"Adresa unde soliciți furnizarea de gaze naturale."}
                           type={"consum"}
                           judetePremier={true}
                           formikValues={formik.values.consum}
                           setFieldValue={formik.setFieldValue}
                           handleChange={formik.handleChange}
                           formikErrors={formik.errors.consum}
                           formikTouched={formik.touched.consum}
                           isDisabled={true}
                        />
                        <div className="row row-input mt-30">
                           <div className="col-md-12">
                              <label htmlFor="adresaConsumDomiciliu" className="check2">
                                 Adresa locului de consum este aceeași cu adresa de domiciliu
                                 <input
                                    defaultChecked={formik.values.adresaConsumDomiciliu}
                                    value={formik.values.adresaConsumDomiciliu}
                                    onChange={formik.handleChange}
                                    id="adresaConsumDomiciliu"
                                    type="checkbox"
                                    className={formik.errors.adresaConsumDomiciliu && formik.touched.adresaConsumDomiciliu ? "error-msg-input" : ""}
                                 />
                                 <span className="checkmark2"></span>
                              </label>
                           </div>

                           {formik.values.adresaConsumDomiciliu === false && (
                              <Adresa
                                 title={"ADRESA DE DOMICILIU"}
                                 type={"domiciliu"}
                                 formikValues={formik.values.domiciliu}
                                 setFieldValue={formik.setFieldValue}
                                 handleChange={formik.handleChange}
                                 formikErrors={formik.errors.domiciliu}
                                 formikTouched={formik.touched.domiciliu}
                              />
                           )}
                        </div>
                        <p className="contr-sub">DATE DE CONTACT</p>
                        <div className="row row-input mt-50">
                           <div className="col-md-6 mb-768">
                              <label htmlFor="telefon">Telefon mobil</label>
                              <div className="placeholder-phone">
                                 <CustomInput
                                    id={"telefon"}
                                    name={"telefon"}
                                    type={"text"}
                                    value={formik.values.telefon}
                                    error={formik.errors.telefon}
                                    touched={formik.touched.telefon}
                                    setFieldValue={formik.setFieldValue}
                                    placeholder={"Numarul dvs de telefon"}
                                    maxLengthNumber={tipCetatenie === "ROMAN" ? 8 : undefined}
                                    phone={tipCetatenie === "ROMAN" ? true : false}
                                    customStyle={tipCetatenie === "ROMAN" && "input-phone"}
                                    allowNumbersAndPlus={tipCetatenie === "ROMAN" ? undefined : true}
                                 />
                              </div>
                           </div>
                           <div className="col-md-6">
                              <label htmlFor="email">E-mail</label>
                              <CustomInput
                                 id={"email"}
                                 name={"email"}
                                 type={"email"}
                                 value={formik.values.email}
                                 error={formik.errors.email}
                                 touched={formik.touched.email}
                                 setFieldValue={formik.setFieldValue}
                              />
                           </div>
                        </div>
                        <p className="contr-sub mb-768">
                           Factură Electronică
                           <span>
                              <img alt="" src={require("assets/images/factura-electronica.png")} />
                              Hai să salvăm copacii împreună!
                           </span>
                        </p>
                        <div className="row row-input mt-30">
                           <div className="col-md-12">
                              <label htmlFor="facturaMail" className="check2">
                                 Sunt de acord să primesc pe adresa de e-mail factura în format electronic.
                                 <input
                                    defaultChecked={formik.values.facturaMail}
                                    value={formik.values.facturaMail}
                                    onChange={formik.handleChange}
                                    id="facturaMail"
                                    type="checkbox"
                                    className={formik.errors.facturaMail && formik.touched.facturaMail ? "error-msg-input" : ""}
                                 />
                                 <span className="checkmark2"></span>
                              </label>
                              {formik.values.facturaMail === false && (
                                 <Adresa
                                    title={"ADRESA DE CORESPONDENTA"}
                                    type={"corespondenta"}
                                    formularCorespondenta={true}
                                    formikValues={formik.values.corespondenta}
                                    setFieldValue={formik.setFieldValue}
                                    handleChange={formik.handleChange}
                                    formikErrors={formik.errors.corespondenta}
                                    formikTouched={formik.touched.corespondenta}
                                 />
                              )}
                           </div>
                        </div>
                        <NavigateButtons currentStep={currentStep} setCurrentStep={setCurrentStep} />
                     </form>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}
